import controller from './factures-x.controller';
import template from './factures-x.tpl.html';

export default {
	template,
	controller,
	bindings: {}
};
